import { TemplatePortal } from '@angular/cdk/portal';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { Icons } from '../../../icon/constants/icons.constants';

@Component({
    selector: 'nw-tab',
    template: '<ng-template><ng-content></ng-content></ng-template>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabComponent implements OnInit {
    @Input() label!: string;
    @Input() icon?: Icons.Type;
    @Input() dataTest?: string;
    @Input({ transform: booleanAttribute }) disabled: boolean = false;
    @Input('aria-label') ariaLabel?: string;
    @Input('aria-labelledby') ariaLabelledby?: string;

    @ViewChild(TemplateRef, { static: true })
    implicitContent!: TemplateRef<unknown>;

    public active: boolean = false;
    public content: TemplatePortal | null = null;

    private viewContainerRef: ViewContainerRef = inject(ViewContainerRef);

    public ngOnInit(): void {
        this.content = new TemplatePortal(this.implicitContent, this.viewContainerRef);
    }
}
